import { connect } from 'react-redux';

// selectors
import { getActiveScriptType } from 'current/selectors';
import { 
  getSelectedManagementZonesId, 
  getActiveManagementZones, 
  getScriptBasedManagementZones
} from 'manual/selectors';
import { isResourceTypeLoaded } from 'loading/selectors';

// actions
import { selectManagementZones, adjustForManualPlantingActivity } from 'manual';

// requesters
import { requestManagementZones } from 'manual/requesters';

// components
import { resourceType } from '../constants/loading';
import ManagementZonesLoader from './ManagementZonesLoader';

export default connect(
  state => {
    const previousPrescriptions = getScriptBasedManagementZones(state);
    const hasPreviousPrescriptions = Object.values(previousPrescriptions).reduce(
      (scriptExists, scriptType) => scriptExists || scriptType.length > 0, false);
    const scriptType = getActiveScriptType(state);
    return {
      areManagementZonesLoaded: isResourceTypeLoaded({
        state,
        type: resourceType.MANAGEMENT_ZONES
      }),
      managementZones: getActiveManagementZones(state),
      hasPreviousPrescriptions,
      selectedManagementZonesId: getSelectedManagementZonesId(state),
      scriptType
    };
  },
  dispatch => ({
    onMount: () => dispatch(requestManagementZones()),
    onSelectManagementZones: zonesData => {
      dispatch(adjustForManualPlantingActivity());
      dispatch(selectManagementZones(zonesData));
    }
  })
)(ManagementZonesLoader);
